var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIconOrdered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.392,
    height: 34.392,
    viewBox: "0 0 34.392 34.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146915",
    "data-name": "Rectangle 146915",
    width: 14.947,
    height: 20.34,
    transform: "translate(-1 -2)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189792",
    "data-name": "Group 189792",
    transform: "translate(-916.608 -216.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189806",
    "data-name": "Group 189806",
    transform: "translate(7.608 26.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_42725",
    "data-name": "Path 42725",
    transform: "translate(909 190)",
    fill: "#fbf9d5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.19580078125 33.3916015625 C 12.86974048614502 33.3916015625 8.802620887756348 31.70694160461426 5.743640899658203 28.6479606628418 C 2.684660673141479 25.58898162841797 1.000000834465027 21.52186012268066 1.000000834465027 17.19580078125 C 1.000000834465027 12.86974048614502 2.684660673141479 8.802620887756348 5.743640899658203 5.743640899658203 C 8.802620887756348 2.684660673141479 12.86974048614502 1.000000834465027 17.19580078125 1.000000834465027 C 21.52186012268066 1.000000834465027 25.58898162841797 2.684660673141479 28.6479606628418 5.743640899658203 C 31.70694160461426 8.802620887756348 33.3916015625 12.86974048614502 33.3916015625 17.19580078125 C 33.3916015625 21.52186012268066 31.70694160461426 25.58898162841797 28.6479606628418 28.6479606628418 C 25.58898162841797 31.70694160461426 21.52186012268066 33.3916015625 17.19580078125 33.3916015625 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.19580078125 2 C 13.13685035705566 2 9.320850372314453 3.58064079284668 6.450750350952148 6.450750350952148 C 3.58064079284668 9.320850372314453 2 13.13685035705566 2 17.19580078125 C 2 21.25475120544434 3.58064079284668 25.07075119018555 6.450750350952148 27.94085121154785 C 9.320850372314453 30.81096076965332 13.13685035705566 32.3916015625 17.19580078125 32.3916015625 C 21.25475120544434 32.3916015625 25.07075119018555 30.81096076965332 27.94085121154785 27.94085121154785 C 30.81096076965332 25.07075119018555 32.3916015625 21.25475120544434 32.3916015625 17.19580078125 C 32.3916015625 13.13685035705566 30.81096076965332 9.320850372314453 27.94085121154785 6.450750350952148 C 25.07075119018555 3.58064079284668 21.25475120544434 2 17.19580078125 2 M 17.19580078125 0 C 26.69278144836426 0 34.3916015625 7.698820114135742 34.3916015625 17.19580078125 C 34.3916015625 26.69278144836426 26.69278144836426 34.3916015625 17.19580078125 34.3916015625 C 7.698820114135742 34.3916015625 0 26.69278144836426 0 17.19580078125 C 0 7.698820114135742 7.698820114135742 0 17.19580078125 0 Z",
    stroke: "none",
    fill: "#faf48a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_251",
    "data-name": "Ellipse 251",
    transform: "translate(909 194)",
    fill: "#f26e14",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_189937",
    "data-name": "Group 189937",
    transform: "translate(919.722 199.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189937-2",
    "data-name": "Group 189937",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42977",
    "data-name": "Path 42977",
    d: "M.958,16.34a1.206,1.206,0,0,1-.925-.892,2.26,2.26,0,0,1,.043-.885c.128-1,.265-2,.4-3s.267-2,.4-3,.265-1.989.4-2.984c.054-.405.1-.811.164-1.215a1.131,1.131,0,0,1,1.05-.953c.563-.023,1.127-.012,1.69-.015.3,0,.249.007.251-.244,0-.372,0-.744,0-1.116a2.048,2.048,0,0,1,4.1,0c0,.393.006.787,0,1.18,0,.139.034.184.176.182.51-.008,1.021,0,1.531,0A1.2,1.2,0,0,1,11.551,4.57c.2,1.505.4,3.01.6,4.515q.262,1.973.522,3.947.13.979.261,1.958a1.164,1.164,0,0,1-.865,1.323c-.025.007-.049.018-.074.027Zm5.5-.692h5.23c.4,0,.6-.206.55-.58-.147-1.132-.3-2.263-.451-3.394q-.233-1.736-.467-3.472-.244-1.831-.485-3.662a.473.473,0,0,0-.5-.442c-.563,0-1.127,0-1.69,0-.114,0-.129.046-.128.141,0,.282,0,.563,0,.845a.354.354,0,0,1-.152.316.338.338,0,0,1-.537-.265c-.018-.3-.012-.595-.009-.892,0-.11-.036-.145-.147-.145q-1.2.006-2.408,0c-.111,0-.15.033-.148.144,0,.282.006.564,0,.845a.349.349,0,1,1-.694-.018c0-.282,0-.563,0-.845,0-.1-.031-.126-.127-.125-.563,0-1.127,0-1.69,0a.472.472,0,0,0-.495.425c-.029.178-.047.358-.071.537q-.2,1.492-.4,2.983t-.4,3l-.4,3c-.046.347-.1.694-.138,1.042a.462.462,0,0,0,.314.541,1.159,1.159,0,0,0,.285.023H6.461m0-12.25c.4,0,.808,0,1.211,0,.106,0,.154-.032.152-.146-.006-.436.009-.872-.013-1.307a1.342,1.342,0,0,0-2.677-.009c-.022.429-.005.861-.014,1.291,0,.134.047.174.176.171.388-.006.776,0,1.164,0",
    transform: "translate(0 0)",
    fill: "#e8b03e",
    stroke: "#e8b03e",
    strokeWidth: 0.25
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconOrdered);
export default __webpack_public_path__ + "static/media/notification-icon-ordered.351e24f074817206cbd3b2f825979d5f.svg";
export { ForwardRef as ReactComponent };